import { AxiosResponse } from "axios";

const convert = <T>({ data }: AxiosResponse<T>): T => data;
const ConvertCount = ({ data }: AxiosResponse): number => data && parseInt(data.count, 10);

export default { convert, ConvertCount };
